import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// NOTE on token storage:
// We use localStorage because the platform ingress is configured with `Access-Control-Allow-Origin: *`,
// which prevents browsers from sending cookie credentials cross-origin. The backend ALSO sets an
// httpOnly `access_token` cookie (which is the safer transport when same-site is possible).
// XSS exposure is the trade-off — mitigations: short JWT expiry (12h), CSP headers in production,
// and avoid rendering untrusted HTML.
const TOKEN_KEY = "eas_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);

// Wipe absolutely everything related to this app's session
export const clearToken = () => {
  try { localStorage.removeItem(TOKEN_KEY); } catch (err) { logSilent("clearToken/local", err); }
  try {
    // Belt-and-braces: clear any other localStorage/sessionStorage keys we might add later
    Object.keys(localStorage)
      .filter((k) => k.startsWith("eas_") || k.startsWith("auth_"))
      .forEach((k) => localStorage.removeItem(k));
  } catch (err) { logSilent("clearToken/iterate", err); }
  try { sessionStorage.clear(); } catch (err) { logSilent("clearToken/session", err); }
  // Expire any cookies set by the API for this origin (access_token, etc.)
  try {
    const expire = "Thu, 01 Jan 1970 00:00:00 GMT";
    const host = window.location.hostname;
    const baseAttrs = `expires=${expire}; path=/; SameSite=Lax`;
    document.cookie.split(";").forEach((c) => {
      const name = c.split("=")[0].trim();
      if (!name) return;
      // Default-domain cookies
      document.cookie = `${name}=; ${baseAttrs}`;
      // Explicit-domain cookies (host + .host + apex)
      document.cookie = `${name}=; ${baseAttrs}; domain=${host}`;
      const apex = host.split(".").slice(-2).join(".");
      if (apex && apex !== host) {
        document.cookie = `${name}=; ${baseAttrs}; domain=.${apex}`;
      }
    });
  } catch (err) { logSilent("clearToken/cookies", err); }
};

// Internal helper — only logs in dev, silent in production builds.
function logSilent(scope, err) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(`[api:${scope}]`, err?.message || err);
  }
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg) ? e.msg : JSON.stringify(e)).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
}

export const fmtAUD = (n) =>
  Number(n || 0).toLocaleString("en-AU", { style: "currency", currency: "AUD" });
